import { authHeader } from "../../../../../helpers/auth-header";
import { client } from "../../../../../actions";
import { message } from "antd";
import uri from "../../../constants/uri";

const deleteVotingFile = async (votingId, attachId) => {
	try {
		await client.delete(`${uri}/attachment`, {
			headers: authHeader(),
			params: { votingId, attachId },
		});
	} catch (e) {
		console.error(e);
		message.error("Не получилось удалить вложение опроса, попробуйте позже");
	}
};

export default deleteVotingFile;
